export default function(usuarioHeader) {
  return {
    headers: { usuario: usuarioHeader }
  };
}
